export interface WhatsAppTemplateVariables {
  nome?: string;
  primeiro_nome?: string;
  corretor?: string;
  empresa?: string;
  telefone?: string;
  email?: string;
  seguro?: string;
  seguradora?: string;
  placa?: string;
  modelo?: string;
  cidade?: string;
  documentos?: string;
  valor?: string;
  link?: string;
  numero_apolice?: string;
  data_vencimento?: string;
  responsavel?: string;
  etapa_funil?: string;
}

export const applyWhatsAppTemplateVariables = (content: string, variables: WhatsAppTemplateVariables): string => {
  const replacements: Record<string, string> = {
    nome: variables.nome || '',
    primeiro_nome: variables.primeiro_nome || variables.nome?.split(' ')[0] || '',
    corretor: variables.corretor || '',
    empresa: variables.empresa || '',
    telefone: variables.telefone || '',
    email: variables.email || '',
    seguro: variables.seguro || '',
    seguradora: variables.seguradora || '',
    placa: variables.placa || '',
    modelo: variables.modelo || '',
    cidade: variables.cidade || '',
    documentos: variables.documentos || '',
    valor: variables.valor || '',
    link: variables.link || '',
    numero_apolice: variables.numero_apolice || '',
    data_vencimento: variables.data_vencimento || '',
    responsavel: variables.responsavel || '',
    etapa_funil: variables.etapa_funil || ''
  };

  return content.replace(/\{\{(\w+)\}\}/g, (match, variableName) => {
    const replacement = replacements[variableName.toLowerCase()];
    return replacement !== undefined && replacement !== '' ? replacement : match;
  });
};

export const buildWhatsAppDeepLink = (phone: string, message: string): string | null => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 10) {
    return null;
  }

  const normalized = digits.startsWith('55') ? digits : `55${digits}`;
  return `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`;
};
